import Avatar from 'components/common/Avatar/Avatar'
import { Button } from 'components/common/button/Button'
import { AnalyticsActionType } from 'types/analytics.type'

import styles from './MiniBanner.module.scss'
import { MiniBannerData } from './MiniBannerData'
import { trackAnalytics } from '../../utils/analytics'
import { Flex } from '../common/flex/Flex'
import TitleText from '../common/titleText/TitleText'

const handleAnalytics = (event: string) => {
  trackAnalytics({
    type: AnalyticsActionType.action,
    payload: event,
  })
}

const MiniBanner = ({ marketingFocused }: { marketingFocused: boolean }) => {
  const bannerData = MiniBannerData()

  const randomAvatarBgColor = ['#22d3ee', '#c880b2', '#d67e84', '#7b90df']

  const getRandomAvatarBgColor = () => randomAvatarBgColor[Math.floor(Math.random() * randomAvatarBgColor.length)]

  return (
    <>
      <Flex className={styles.container}>
        {bannerData
          .filter(item => !(item.isMarketingFocused && !marketingFocused))
          .map(item => {
            const imageElement = item.name ? (
              <Avatar
                size="l"
                variant="circle"
                src={item.img}
                name={item.name}
                bgColor={getRandomAvatarBgColor()}
                color="#fff"
              />
            ) : (
              <img src={item.img} alt="New Project" className="w-full h-full object-cover rounded-full" />
            )

            return (
              <Flex
                key={item.title}
                className={styles.contentContainer}
                style={{ backgroundColor: item.backgroundColor }}
              >
                <div className={styles.imgContainer}>{imageElement}</div>
                <TitleText
                  titleType="xl-heading"
                  titleTag="p"
                  titleClassName={`${styles.title} text-[#fff]`}
                  textType="m-body"
                  textTag="p"
                  textClassName={`${styles.text} text-[#fff]`}
                  title={item.title}
                  text={item.description}
                  containerClassName={styles.titleTextContainer}
                >
                  <Button
                    variant="secondary"
                    size="fit"
                    className="bg-white border-black max-w-[230px] text-[#000]"
                    disabled={!item.button.link}
                    onClick={() => {
                      handleAnalytics(item.event_type)
                      window.open(item.button.link, '_blank')
                    }}
                    text={item.button.text}
                  />
                </TitleText>
              </Flex>
            )
          })}
      </Flex>
      <div
        style={{ backgroundColor: '#000000' }}
        className="flex flex-col h-full items-center overflow-y-auto overflow-x-hidden"
      >
        <div className="bg-transparent px-24 pt-16" />
        <div style={{ backgroundColor: '#000000' }} className="flex-1 w-[150%] px-[25%] mt-64">
          <svg
            width="100%"
            height="300"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
            className="-mt-[320px]"
            stroke="white"
            style={{ transform: 'scaleY(-1)' }}
          >
            <path d="M0,100 Q50,0 100,100 Z" fill="#FFFFFF" />
          </svg>
        </div>
      </div>
    </>
  )
}

export default MiniBanner
